var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimetracking = function SvgTimetracking(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#timetracking_svg__a)",
    rx: 16
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#timetracking_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "timetracking_svg__c",
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#timetracking_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.908 23.5q-3.143 0-5.323-2.181t-2.181-5.323q0-3.119 2.18-5.308Q15.768 8.5 18.909 8.5q3.12 0 5.307 2.188 2.19 2.19 2.189 5.308 0 3.143-2.189 5.323T18.908 23.5m-.004-1.5q2.5 0 4.25-1.75t1.75-4.25-1.75-4.25-4.25-1.75-4.25 1.75-1.75 4.25 1.75 4.25 4.25 1.75m.75-6.294v-2.802a.73.73 0 0 0-.216-.534.73.73 0 0 0-.535-.216.73.73 0 0 0-.534.216.73.73 0 0 0-.215.534v3.054q0 .176.073.342.073.165.2.293l2.32 2.33a.7.7 0 0 0 .53.233.74.74 0 0 0 .54-.233.73.73 0 0 0 .233-.534.74.74 0 0 0-.233-.535zM7.346 12.75a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.534a.73.73 0 0 1 .534-.216h2.308q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.534a.73.73 0 0 1-.534.216zm-1 4a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.534a.73.73 0 0 1 .534-.216h3.308q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215zm1 4a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.535a.73.73 0 0 1 .534-.215h2.308q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "timetracking_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "timetracking_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimetracking);
export default ForwardRef;